import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import OurProducts from "./pages/OurProducts";
import GoldJewelleries from "./pages/GoldJewelleries";
import SilverJewelleries from "./pages/SilverJewelleries";
import PreciousStones from "./pages/PreciousStones";
import SemiPreciousStones from "./pages/SemiPreciousStones";
import GemHistory from "./pages/GemHistory";
import Blogs from "./pages/Blogs";
import ContactUs from "./pages/ContactUs";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-products" element={<OurProducts />} />
        <Route path="/gold-jewellery" element={<GoldJewelleries />} />
        <Route path="/silver-jewellery" element={<SilverJewelleries />} />
        <Route path="/precious-stones" element={<PreciousStones />} />
        <Route path="/semi-precious-stones" element={<SemiPreciousStones />} />
        <Route path="/gem-history" element={<GemHistory />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/blogs" element={<Blogs />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;